module.exports = __webpack_public_path__ + "img/champagne_cocktail.f9014c1e.jpg";